<template>
  <el-row>
    <el-card shadow="never" class="mt-0 card-promo">
      <el-checkbox-group
        v-model="Promo.promoTargetStrata.boundary.boundaryType"
        style="width: 100%"
      >
        <template v-for="(formcheck, idx) in formCheck">
          <el-row :key="idx" type="flex" justify="space-between">
            <el-col :span="6">
              <el-checkbox :label="formcheck.value" class="mt-2">{{ formcheck.label }}</el-checkbox>
            </el-col>
            <el-col :span="14">
              <el-form-item size="small" style="margin: 0">
                <el-row type="flex" justify="space-between" style="flex-wrap: wrap">
                  <template v-for="(form, idx) in formcheck.form">
                    <el-col :span="form.span" style="margin-bottom: 18px" :key="idx">
                      <el-input
                        v-if="(form.type == 'text' || form.type == 'password' || form.type == 'number') && (formcheck.value === 'qty' || formcheck.value === 'value' )"
                        v-model="Promo.promoTargetStrata.boundary[formcheck.value][form.id]"
                        :placeholder="form.placeholder"
                        :type="form.type"
                        :disabled="disabledField(formcheck.value)"
                      ></el-input>
                      <el-input
                        v-else-if="form.type == 'text' || form.type == 'password' || form.type == 'number'"
                        v-model="Promo.promoTargetStrata.boundary[form.id]"
                        :placeholder="form.placeholder"
                        :type="form.type"
                        :disabled="disabledField(formcheck.value)"
                      ></el-input>
                      <el-select
                        v-else-if="form.type == 'select'"
                        v-model="Promo.promoTargetStrata.boundary[form.id]"
                        style="width: 100%"
                        filterable
                        remote
                        :remote-method="form.onSearch"
                        :loading="form.onLoading"
                        :disabled="disabledField(formcheck.value)"
                      >
                        <el-option
                          v-for="item in form.data"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                        <el-row v-if="form.loadMore" type="flex" justify="center">
                          <el-button
                            :loading="form.onLoading"
                            size="mini"
                            round
                            @click="form.loadMore"
                          >Load More</el-button>
                        </el-row>
                      </el-select>
                    </el-col>
                    {{ form.satuan }}
                  </template>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-checkbox-group>
    </el-card>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["Promo"],
  data() {
    return {
      limitBranch: 25,
      limitProvince: 25,
      limitRegencies: 25,
      limitDistricts: 25,
    };
  },
  computed: {
    ...mapState({
      branchs: state => state.branch.branchs,
      provinces: state => state.area.provinces,
      regencies: state => state.area.regencies,
      districts: state => state.area.districts
    }),
    formCheck() {
      return [
        {
          label: "Branch",
          value: "branch",
          form: [
            {
              type: "select",
              id: "branch",
              label: "",
              rules: [],
              data: this.branchs.data.map(item => {
                item.name = `${item.branchCode} - ${item.branch}`;
                item.value = item.branchCode;
                return item;
              }),
              loadMore: this.loadMoreBranch,
              onSearch: this.onSearchBranch,
              onLoading: this.branchs.isLoading
            }
          ]
        },
        {
          label: "Province",
          value: "province",
          form: [
            {
              type: "select",
              id: "province",
              label: "",
              rules: [],
              multiple: true,
              data: this.provinces.data.map(item => {
                item.name = `${item.province}`;
                item.value = item.name;
                return item;
              }),
              loadMore: null,
              onSearch: null,
              onLoading: this.provinces.isLoading
            }
          ]
        },
        {
          label: "Regency",
          value: "regency",
          form: [
            {
              type: "select",
              id: "regency",
              label: "",
              rules: [],
              multiple: true,
              data: this.regencies.data.map(item => {
                item.name = `${item.regency}`;
                item.value = item.regencyId;
                return item;
              }),
              loadMore: null,
              onSearch: null,
              onLoading: this.regencies.isLoading
            }
          ]
        },
        {
          label: "District",
          value: "district",
          form: [
            {
              type: "select",
              id: "district",
              label: "",
              rules: [],
              multiple: true,
              data: this.districts.data.map(item => {
                item.name = `${item.district}`;
                item.value = item.districtId;
                return item;
              }),
              loadMore: null,
              onSearch: null,
              onLoading: this.districts.isLoading
            }
          ]
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      getBranch: "branch/GetBranchs",
      getProvinces: "area/GetProvinces",
      getRegencies: "area/GetRegencies",
      getDistricts: "area/GetDistricts"
    }),
    disabledField(value) {
      return !this.Promo.promoTargetStrata.boundary.boundaryType.includes(value)
    },
    onSearchBranchs(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getBranch(option);
    },
    loadMoreBranch() {
      this.limitBranch += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitBranch,
        }
      };
      this.getBranch(option);
    },
  },
  watch: {
    'Promo.promoTargetStrata.boundary.province': {
      handler: function (val) {
        this.getRegencies(val)
      },
      deep: true
    },
    'Promo.promoTargetStrata.boundary.regency': {
      handler: function (val) {
        this.getDistricts(val)
      },
      deep: true
    }
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getBranch(option);
    this.getProvinces(option);
  }
};
</script>

<style>
.tab-promo /deep/ .el-tabs__item {
  padding: 0px 20px !important;
}
.tab-promo /deep/ .el-tabs__item.is-active {
  color: white !important;
  background-color: #2356c9;
  padding: 0px 20px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bold;
}
.tab-promo /deep/ .el-tabs__header.is-top {
  margin: 0 !important;
}
.card-promo {
  background-color: #f6f6f6 !important;
}
</style>
